(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TestSchedule', TestSchedule);

    TestSchedule.$inject = ['$resource', 'DateUtils'];

    function TestSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/test-schedule/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byObjTypeAndFleet': {url:"api/test-schedule/by-obj-type/:typeId/fleet/:fleetId", method: 'GET', isArray: true},
            'byObjects': {url:"api/test-schedule/by-objects", method: 'POST', isArray: true},
            'create': {method:'POST'},
            'update': {method: 'PUT'},
            'manage': {method: 'PUT', url:"api/test-schedule/manage-schedule"},
            'runSchedule': {method: 'PUT', url:"api/test-schedule/run-schedule"},
            'delete': {method: 'DELETE'}
        });
    }
})();
